import { Button, Modal, Switch } from '@evaneos/b2b-ui/legacy';

import { useIntl } from 'react-intl';

import agentAwayPreview from '../../../assets/agent-away-preview.png';
import { ExpandableContainer } from '../../../design-system/ExpandableContainer/ExpandableContainer';
import { useSetAgentAwayStatusMutation } from '../../../resources/agentSettings/mutations';
import { useTrackEventAmplitude } from '../../analytics';

import s from './AgentAwayStatusModal.css';

interface Props {
    modalOpened: boolean;
    openModal: (value: boolean) => void;
    agentAwayStatusChecked: boolean;
    handleAgentAwayStatus: (value: boolean) => void;
}

export const AgentAwayStatusModal = ({
    modalOpened,
    openModal,
    agentAwayStatusChecked,
    handleAgentAwayStatus,
}: Props) => {
    const intl = useIntl();
    const { mutate: setAgentAwayStatus } = useSetAgentAwayStatusMutation();
    const { trackEvent } = useTrackEventAmplitude();

    function submitIsAgentAwayStatus(): void {
        setAgentAwayStatus(agentAwayStatusChecked);
        openModal(false);
        trackEvent((ampli, defaultProperties) => {
            ampli.absenceStatusSubmitted({
                ...defaultProperties,
                absence_status_checked: agentAwayStatusChecked,
            });
        });
    }

    return (
        <Modal
            isOpen={modalOpened}
            onRequestClose={() => openModal(false)}
            mainButton={
                <Button
                    priority="primary"
                    onClick={submitIsAgentAwayStatus}
                    data-testid="agent-away-modal-submit-button"
                >
                    {intl.formatMessage({ id: 'form.submit' })}
                </Button>
            }
            title={intl.formatMessage({
                id: 'agent_settings.is_away.modal.title',
            })}
        >
            <Switch
                id={'toggle-switch'}
                className={s.toggleSwitch}
                checked={agentAwayStatusChecked}
                value={0}
                onChange={(e) => handleAgentAwayStatus(e.target.checked)}
                title={
                    agentAwayStatusChecked
                        ? intl.formatMessage({
                              id: 'agent_settings.is_away.modal.switch_on',
                          })
                        : intl.formatMessage({
                              id: 'agent_settings.is_away.modal.switch_off',
                          })
                }
                labelPositionEnd={true}
                data-testid="agent-away-modal-switch"
            />
            <p>
                {intl.formatMessage({
                    id: 'agent_settings.is_away.modal.explanation_part_1',
                })}
            </p>
            <p>
                {intl.formatMessage({
                    id: 'agent_settings.is_away.modal.explanation_part_2',
                })}
            </p>

            <ExpandableContainer
                previewTitle={intl.formatMessage({
                    id: 'agent_settings.is_away.modal.preview_title',
                })}
                content={<img src={agentAwayPreview} />}
            />
        </Modal>
    );
};
